import { call } from 'redux-saga/effects';

import api from 'api';

export function* postGoogleAnalyticsId() {
    try {
        yield call(api.user.postGoogleAnalyticsId);
    } catch (error) {
        console.error(error);
    }
}
